module.exports = __webpack_public_path__ + "img/web3icon10.415c6830.png";